import { SET_DISCOUNTS } from '../actions/types'

const initialState = {
  discounts: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DISCOUNTS:
      return {
        ...state,
        discounts: action.discounts,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducers/promotions.js